<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <bita-bootbutton
            title="افزودن واحد اندازه گیری"
            type="primary"
            icon="fas fa-plus-square"
            btn-width="200px"
            @click.native="toggleModal"
            v-if="$acl.can('create', 'measures')"
          />
          <hr />
          <bita-grid ref="grid" :columns="gridColumns" :read-data="readData" />
        </div>
      </bita-ibox>
    </div>
    <measure-form
      ref="form"
      :title="formTitle"
      :is-loading="isLoadingModal"
      @on-create="(e) => save(e)"
      @on-update="(e) => update(e)"
    />
  </div>
</template>
<script>
import MeasureForm from "./components/MeasureForm";
import { measureApi } from "@/api/apiManagement";

export default {
  components: { MeasureForm },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        { title: "مدیریت واحد اندازه گیری", link: "" },
      ],
      isLoadingModal: false,
      isLoadingGrid: false,
      formTitle: "",
      measures: [],
    };
  },
  mounted() {
    this.loadData();
  },
  computed: {
    gridColumns() {
      let commands = [];

      if (this.$acl.can("edit", "measures"))
        commands.push({
          text: "ویرایش",
          name: "my",
          // template: this.gridButtons.edit,
          click: this.editRow,
        });

      if (this.$acl.can("delete", "measures"))
        commands.push({
          text: "حذف",
          name: "delete",
          // template: this.gridButtons.delete,
          click: this.delete,
        });
      return [
        { field: "name", title: "واحد" },
        {
          title: "عملیات",
          command: commands,
        },
      ];
    },
  },

  methods: {
    save(measure) {
      this.isLoadingModal = true;

      measureApi
        .createMeasure(measure)
        .then((res) => {
          this.formSucceeded(res.data.message);
          this.toggleModal();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    formSucceeded(message) {
      this.$izitoast("success", "عملیات موفق", message);
      this.$refs.form.reset();
      this.toggleModal();
      this.loadData();
    },
    update(measure) {
      this.isLoadingModal = true;

      measureApi
        .updateMeasure(measure.id, measure)
        .then((res) => {
          this.formSucceeded(res.data.message);
        })
        .catch((err) => {
          this.$refs.form.setErrors(err.response.data.errors);
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    toggleModal() {
      this.$toggleModal("#measure-form");
    },
    editRow(e) {
      e.preventDefault();
      let measure = this.$refs.grid.getSelectedGridRow(e);
      let editForm = {
        id: measure.id,
        name: measure.name,
      };
      this.formTitle = `ویرایش ${measure.name}`;
      this.toggleModal();
      this.$refs.form.setForm(editForm);
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    readData(e) {
      this.isLoadingGrid = true;
      // this.$resetGrid();
      measureApi
        .getMeasures()
        .then(({ data }) => {
          e.success(data.entity);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    delete(e) {
      e.preventDefault();
      let measure = this.$refs.grid.getSelectedGridRow(e);
      this.$alert("question", `آیا از حذف ${measure.name} اطمینان دارید؟`, "", {
        confirmButtonText: "بله",
      }).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          measureApi
            .deleteMeasure(measure.id)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
  },
};
</script>
<style scoped>
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-leave {
  opacity: 0.2;
}
table td {
  text-align: center;
}
</style>
